module.exports = __webpack_public_path__ + "static/media/logoGray.e6db25aa.svg";